import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Layout, Modal } from "antd";
import { UnorderedListOutlined } from "@ant-design/icons";

import AppDrawer from "../AppDrawer";
import ExerciceSelect, { exerciceLabel } from "../ExerciceSelect";
import SearchInput from "../SearchInput";
import UserInfo from "../UserInfo";
import { SIDEBAR, subfolder } from "../../utils/constants";
import { setExercice } from "../../store/actions/exerciceAction";

const { Header } = Layout;

// En-tête applicatif pleine largeur, au-dessus de la sidebar et du contenu.
// Fond : token Layout.headerBg (ConfigProvider, App.js). Hauteur : valeur par défaut antd.
// La zone logo a la largeur de la sidebar dépliée.
const logoZoneStyle = {
  width: SIDEBAR.WIDTH,
  flex: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const searchStyle = {
  width: 400,
  marginLeft: 16,
  alignSelf: "center",
};

// Poussé à droite ; display flex pour que UserInfo s'étire sur toute la hauteur du header
const userInfoZoneStyle = {
  marginLeft: "auto",
  display: "flex",
};

const drawerButtonStyle = {
  alignSelf: "center",
  marginRight: 16,
};

const exerciceSelectStyle = {
  alignSelf: "center",
  marginLeft: 16,
};

const AppHeader = ({ utilisateur, addPanesPersonne, addPanesLot, handleSelectRequete, loading }) => {
  const parametre = useSelector((state) => state.parametre.data);
  // Local : seul le header pilote l'ouverture du drawer ; Router ne fournit que le callback handleSelectRequete
  const [drawerOpen, setDrawerOpen] = useState(false);
  const exercice = useSelector((state) => state.exercice.annee);
  const dispatch = useDispatch();
  // Hook plutôt que Modal.confirm statique : la modale hérite du ConfigProvider (thème, locale)
  const [modal, contextHolder] = Modal.useModal();

  // Le changement réinitialise toute l'application : confirmation obligatoire.
  // Sur Annuler, rien à faire : le Select est contrôlé et garde l'exercice du store.
  const handleExerciceChange = (annee) => {
    modal.confirm({
      title: "Changer d'exercice ?",
      content: `Passer à l'exercice ${exerciceLabel(annee)} fermera tous les onglets ouverts et rechargera l'application. Les saisies non enregistrées seront perdues.`,
      okText: "Confirmer",
      cancelText: "Annuler",
      centered: true,
      onOk: () => dispatch(setExercice(annee)),
    });
  };

  return (
    <Header style={{ display: "flex", padding: 0 }}>
      <div className="ast-logo" style={logoZoneStyle}>
        <img
          src={`${subfolder}/aster-noir.png`}
          alt="Aster"
          style={{ maxWidth: "100%", maxHeight: "100%" }}
        />
      </div>
      <ExerciceSelect
        value={exercice}
        onChange={handleExerciceChange}
        // Bloqué pendant le chargement initial : ses réponses arriveraient dans le store réinitialisé
        disabled={loading}
        style={exerciceSelectStyle}
      />
      <SearchInput
        addPanesPersonne={addPanesPersonne}
        addPanesLot={addPanesLot}
        placeholder="recherche..."
        style={searchStyle}
      />
      <div style={userInfoZoneStyle}>
        {/* Le drawer ne contient que l'arbre du parcours client */}
        {parametre?.parametre_parcours_client && (
          <Button
            type="text"
            className="app-drawer-toggle"
            icon={<UnorderedListOutlined />}
            onClick={() => setDrawerOpen((open) => !open)}
            style={drawerButtonStyle}
          />
        )}
        <UserInfo utilisateur={utilisateur} />
      </div>
      <AppDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        handleSelectRequete={handleSelectRequete}
      />
      {contextHolder}
    </Header>
  );
};

export default AppHeader;
